import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { showErrorToast, showSuccessToast } from "#app/notifications";
import { resetPassword } from "#modules/auth/infra/resetPassword.api";
import { ROUTES } from "#shared/routes";

export const useResetPassword = () => {
  const navigate = useNavigate();

  const { mutate, ...rest } = useMutation({
    mutationFn: resetPassword,
    onSuccess: () => {
      showSuccessToast({ title: "Votre mot de passe a été réinitialisé" });
      navigate(ROUTES.login);
    },
    onError: () => {
      showErrorToast({
        title: "Une erreur est survenue",
        message: "Le token est peut être invalide ou a expiré",
      });
    },
  });

  return { resetPassword: mutate, ...rest };
};
